module.exports = __webpack_public_path__ + "4efeaf625e317abd8beaea039382a5fb.svg";


//////////////////
// WEBPACK FOOTER
// ./app/pages/Employees/Staff/StaffList/EmailStatus/ic-resend.svg
// module id = 3176
// module chunks = 0